function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.571 8.268L.43 2.345C-.143 1.794-.143.968.429.417a1.417 1.417 0 012 0L9.57 7.304c.286.275.429.688.429.964 0 .413-.143.826-.429 1.102L2.43 16.257c-.572.55-1.429.55-2 0-.572-.551-.572-1.378 0-1.929l6.142-6.06z",
  fill: "#fff"
});

var SvgBannerArrow = function SvgBannerArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxMCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjU3MTQzIDguMjY3NzhMMC40Mjg1NzEgMi4zNDQ5MUMtMC4xNDI4NTcgMS43OTM5NSAtMC4xNDI4NTcgMC45Njc1MDUgMC40Mjg1NzEgMC40MTY1NEMxIC0wLjEzNDQyNCAxLjg1NzE0IC0wLjEzNDQyNCAyLjQyODU3IDAuNDE2NTRMOS41NzE0MyA3LjMwMzU5QzkuODU3MTQgNy41NzkwNyAxMCA3Ljk5MjMgMTAgOC4yNjc3OEMxMCA4LjY4MSA5Ljg1NzE0IDkuMDk0MjMgOS41NzE0MyA5LjM2OTcxTDIuNDI4NTcgMTYuMjU2OEMxLjg1NzE0IDE2LjgwNzcgMSAxNi44MDc3IDAuNDI4NTcxIDE2LjI1NjhDLTAuMTQyODU3IDE1LjcwNTggLTAuMTQyODU3IDE0Ljg3OTMgMC40Mjg1NzEgMTQuMzI4NEw2LjU3MTQzIDguMjY3NzhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgBannerArrow as ReactComponent };